import Icon from '@ant-design/icons';

const NdeCalmingSvg = () => (
  <svg width="1.1em" height="1.1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 700" fill="currentColor">
    <g>
      <path d="M350,333.8c38.6,0,70-31.4,70-70c0-38.6-31.4-70-70-70s-70,31.4-70,70C280,302.4,311.4,333.8,350,333.8z M350,211.2
		c29,0,52.5,23.5,52.5,52.5S379,316.2,350,316.2s-52.5-23.5-52.5-52.5S321,211.2,350,211.2z"/>
      <path d="M350,176.2c4.8,0,8.8-3.9,8.8-8.8v-43.6c0-4.8-3.9-8.8-8.8-8.8s-8.8,3.9-8.8,8.8v43.8C341.2,172.3,345.2,176.2,350,176.2z"
      />
      <path d="M358.8,403.8V360c0-4.8-3.9-8.8-8.8-8.8s-8.8,3.9-8.8,8.8v43.8c0,4.8,3.9,8.8,8.8,8.8S358.8,408.6,358.8,403.8z"/>
      <path d="M437.5,263.8c0,4.8,3.9,8.8,8.8,8.8H490c4.8,0,8.8-3.9,8.8-8.8c0-4.9-3.9-8.8-8.8-8.8h-43.8
		C441.4,255,437.5,258.9,437.5,263.8z"/>
      <path d="M210,272.5h43.8c4.8,0,8.8-3.9,8.8-8.8c0-4.9-3.9-8.8-8.8-8.8H210c-4.8,0-8.8,3.9-8.8,8.8
		C201.2,268.6,205.2,272.5,210,272.5z"/>
      <path d="M418.1,204.4c2.2,0,4.5-0.9,6.2-2.6l30.9-30.9c3.4-3.4,3.4-9,0-12.4s-9-3.4-12.4,0l-30.9,30.9c-3.4,3.4-3.4,9,0,12.4
		C413.6,203.6,415.8,204.4,418.1,204.4L418.1,204.4z"/>
      <path d="M288.1,325.6c-3.4-3.4-9-3.4-12.4,0l-30.9,30.9c-3.4,3.4-3.4,9,0,12.4c1.7,1.7,3.9,2.6,6.2,2.6c2.2,0,4.5-0.9,6.2-2.6
		l30.9-30.9C291.5,334.6,291.5,329,288.1,325.6L288.1,325.6z"/>
      <path d="M449,371.5c2.2,0,4.5-0.9,6.2-2.6c3.4-3.4,3.4-9,0-12.4l-30.9-30.9c-3.4-3.4-9-3.4-12.4,0s-3.4,9,0,12.4l30.9,30.9
		C444.5,370.6,446.8,371.5,449,371.5L449,371.5z"/>
      <path d="M275.8,201.9c1.7,1.7,3.9,2.6,6.2,2.6c2.2,0,4.5-0.9,6.2-2.6c3.4-3.4,3.4-9,0-12.4l-30.9-30.9c-3.4-3.4-9-3.4-12.4,0
		c-3.4,3.4-3.4,9,0,12.4L275.8,201.9z"/>
      <path d="M474.2,538.8c4-6.7,7.3-13.9,9.9-21.3h5.9c19.3,0,35-15.7,35-35s-15.7-35-35-35V465c9.7,0,17.5,7.8,17.5,17.5
		S499.6,500,490,500h-1.6c0.9-5.7,1.6-11.5,1.6-17.5h-17.5c0,57.9-54.9,105-122.5,105s-122.5-47.1-122.5-105H210
		c0,6,0.7,11.8,1.6,17.5H210c-9.7,0-17.5-7.8-17.5-17.5S200.3,465,210,465v-17.5c-19.3,0-35,15.7-35,35s15.7,35,35,35h5.9
		c2.5,7.4,5.9,14.5,9.9,21.3c-85.6,19.5-125.2,58.3-127,60.1l12.4,12.4c0.4-0.4,40-39,125.7-56.8C262.3,585,303.5,605,350,605
		s87.7-20,113.1-50.7c85.2,17.8,125.3,56.5,125.7,56.9l12.4-12.4C599.4,597.1,559.8,558.2,474.2,538.8L474.2,538.8z"/>
      <path d="M323.8,447.5v35c0,14.5,11.8,26.2,26.2,26.2c14.5,0,26.3-11.8,26.3-26.2v-35h-17.5v35c0,4.8-3.9,8.8-8.8,8.8
		c-4.8,0-8.7-3.9-8.7-8.8v-35H323.8z"/>
      <path d="M288.8,451.9c0,7.2-5.9,13.1-13.1,13.1s-13.1-5.9-13.1-13.1s5.9-13.1,13.1-13.1S288.8,444.6,288.8,451.9"/>
      <path d="M437.5,451.9c0,7.2-5.9,13.1-13.1,13.1s-13.1-5.9-13.1-13.1s5.9-13.1,13.1-13.1S437.5,444.6,437.5,451.9"/>
      <path d="M291.9,533c0.4,0.3,26.2,21.4,60.4,21.4c17.2,0,36.5-5.3,55.8-21.4l-11.2-13.4c-46.1,38.4-91.9,1.6-93.8,0L291.9,533z"/>
    </g>
  </svg>
);

export const NdeCalmingIcon = props => <Icon component={NdeCalmingSvg} {...props} />;
